import axios from "axios";

// 输出当前时间
const printNow = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
};

// debug
export const consoleDebug = (funcName, msg) => {
  if (axios.justle != "production") {
    console.log(printNow(), `| ${funcName}:\n`, msg);
  }
};

// 处理
export const checkExpire = (err, router) => {
  if (err.response && err.response.status && err.response.status == 401) {
    alert("Login expired, please login again!");
    localStorage.removeItem("token");
    router.push("/benefit/login");
  }
};

// 防抖
export const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

// 判断是否为PC端
export const isPC = !navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
// 判断是否为PC端（暂时不启用，默认都是手机）
// export const isPC = false;
